export const tokens = {
  colors: {
    background: '#0A0A0F',
    surface: '#141419',
    surfaceRaised: '#1E1E26',
    border: '#2A2A35',
    textPrimary: '#F0F0F5',
    textSecondary: '#9494A8',
    redAccent: '#E5484D',
    redSubtle: '#3C1618',
    redHover: '#F2555A',
    amberWarn: '#F5A623',
    cyanInfo: '#52A8FF',
    greenOk: '#30A46C',
  },
  // Colorblind-safe chart palette
  chartColors: [
    '#E5484D', // red
    '#52A8FF', // blue
    '#F5A623', // amber
    '#30A46C', // green
    '#9B59B6', // purple
    '#F39C12', // orange
  ],
} as const;
